import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/store/authStore';
import { setLanguage } from '@/i18n';
import { codeFromName } from '@/i18n/languages';

/**
 * Keeps the interface language in step with the signed-in user's saved
 * preference. Before login (or for a user who never chose one) i18next's
 * detector has already picked localStorage → browser language.
 *
 * Runs once per change of the stored preference, so switching accounts on the
 * same browser doesn't leave the previous user's language behind.
 */
export function useLanguageSync() {
  const user = useAuthStore((s) => s.user);
  const { i18n } = useTranslation();

  const preferred = user?.preferences?.language;

  useEffect(() => {
    if (!preferred) return;
    const code = codeFromName(preferred);
    if (code !== i18n.resolvedLanguage) setLanguage(code);
  }, [preferred, i18n.resolvedLanguage]);
}

export default useLanguageSync;
